export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const PURGE_AUTH = "logOut";
export const SET_ARTICLE = "setArticle";
export const SET_AUTH = "setUser";
export const SET_COMMENTS = "setComments";
export const SET_ERROR = "setError";
export const SET_PROFILE = "setProfile";
export const SET_TAGS = "setTags";
export const TAG_ADD = "addTag";
export const TAG_REMOVE = "removeTag";
export const UPDATE_ARTICLE_IN_LIST = "updateArticleInList";
export const RESET_STATE = "resetModuleState";
export const FETCH_START_DECORATION_PRICES = "fetchStartDecorationPrices";
export const FETCH_END_DECORATION_PRICES = "fetchEndDecorationPrices";
export const FETCH_START_DECORATION_TEMPLATE = "fetchStartDecorationTemplate";
export const FETCH_END_DECORATION_TEMPLATE = "fetchEndDecorationTemplate";
export const FETCH_START_ADMIN_OPTIONS = "fetchStartAdminOptions";
export const FETCH_END_ADMIN_OPTIONS = "fetchEndAdminOptions";
export const FETCH_START_ALL_DECORATION_TEMPLATES =
    "fetchStartAllDecorationTemplates";
export const FETCH_END_ALL_DECORATION_TEMPLATES =
    "fetchEndAllDecorationTemplates";
export const FETCH_DECORATIONS_START = "fetchDecorationMethodsStart";
export const FETCH_DECORATIONS_END = "fetchDecorationMethodsEnd";
export const SET_DECORATION_METHOD_NAME_MUTATION = "setDecorationMethodName";
export const UPDATING_ADMIN_LOGGEDIN_STATUS = "updatingAdminLoggedInStatus";
export const FETCH_START_ROLLUP_FEES = "fetchStartRollupFees";
export const FETCH_END_ROLLUP_FEES = "fetchEndRollupFees";
export const FETCH_START_ECOMM_DISPLAY_NAMES = "fetchStartEcommDisplayNames";
export const FETCH_END_ECOMM_DISPLAY_NAMES = "fetchEndEcommDisplayNames";